import axios from 'axios'
import md5 from 'md5'

// import API from '@/API'

export const state = {
  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
  token: localStorage.getItem('token') ? localStorage.getItem('token') : null
}

export const mutations = {
  setUser (state, { user }) {
    state.user = user
    localStorage.setItem('user', JSON.stringify(user))
  },
  setToken (state, { token }) {
    state.token = token
    localStorage.setItem('token', token)
    // API.setAPIAuth(token)
  }
}

export const actions = {
  /**
   * Logs the user user in and stores the user profile and token
   * if successful
   */
  login ({ commit }, { username, password }) {
    return axios.post(`${process.env.VUE_APP_BACKEND}/auth/local`, { identifier: username, password })
      .then((res) => {
        console.log(res)
        commit('setUser', { user: res.data.user })
        commit('setToken', { token: res.data.jwt })
        return res
      })
  },

  /**
   * Registers a user and stores the user profile and token
   * if successful
   */
  register ({ commit }, { username, email, password }) {
    return axios.post(`${process.env.VUE_APP_BACKEND}/auth/local/register`, { username, email, password })
      .then((res) => {
        console.log(res)
        commit('setUser', { user: res.data.user })
        commit('setToken', { token: res.data.jwt })
        return res
      })
  }
}

export const getters = {
  gravatar (state) {
    if (!state.user) { return }
    const hash = md5(state.user.email)
    return `https://www.gravatar.com/avatar/${hash}`
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
